//new AssetSelector(Object.values(SalesToolkit.Library.assets), document.getElementById('assetPicker'), [ {} ])
//[ ]
class AssetSelector {
    constructor(assets, element, resultsPerPage, searchOptions) {
        this.assets = assets;
        
        this.defaultSearchOptions = [
          { name : "copyright", label : this.getTranslation("assetSelector_copyright", "Copyright"), type : "text", placeholder : this.getTranslation('assetSelector_copyright_placeholder') },
          { name : "doiNumber", label : this.getTranslation("assetSelector_doiNumber", "DOI Number"), type : "text", placeholder : this.getTranslation('assetSelector_doiNumber_placeholder') },
          { name : "fullTitle", label : this.getTranslation("assetSelector_fullTitle", "Full Title"), type : "text", placeholder : this.getTranslation('assetSelector_fullTitle_placeholder') },
          { name : "issue", label : this.getTranslation("assetSelector_issue", "Issue"), type : "text", placeholder : this.getTranslation('assetSelector_issue_placeholder') },
          { name : "keywords", label : this.getTranslation("assetSelector_keywords", "Keyword"), type : "text", placeholder : this.getTranslation('assetSelector_keywords_placeholder') },
          { name : "mimetype", label : this.getTranslation("assetSelector_mimetype", "Mimetype"), type : "text", placeholder : this.getTranslation('assetSelector_mimetype_placeholder') },
          { name : "name", label : this.getTranslation("assetSelector_name", "Name"), type : "text", placeholder : this.getTranslation('assetSelector_name_placeholder') },
          { name : "publicationName", label : this.getTranslation("assetSelector_publicationName", "Publication Name"), type : "text", placeholder : this.getTranslation('assetSelector_publicationName_placeholder') },
          { name : "summary", label : this.getTranslation("assetSelector_summary", "Summary"), type : "text", placeholder : this.getTranslation('assetSelector_summary_placeholder') },
          { name : "volume", label : this.getTranslation("assetSelector_volume", "Volume"), type : "text", placeholder : this.getTranslation('assetSelector_volume_placeholder') },
          { name : "authors", label : this.getTranslation("assetSelector_authors", "Authors"), type : "text", placeholder : this.getTranslation('assetSelector_authors_placeholder') },
          { name : "approvalDate", label : this.getTranslation("assetSelector_approvalDate", "Approval Date"), type : "date", placeholder : this.getTranslation('assetSelector_approvalDate_placeholder') },
          { name : "publishDate", label : this.getTranslation("assetSelector_publishDate", "Publish Date"), type : "date", placeholder : this.getTranslation('assetSelector_publishDate_placeholder') },
          { ancestors: true, name : "name", label : this.getTranslation("assetSelector_collection_name", "Collection Name"), type : "text", placeholder : this.getTranslation('assetSelector_collection_name_placeholder') } 
        ];
        this.searchOptions = searchOptions || this.defaultSearchOptions;
        this.uid = this.uuidv4();
        this.parentElement = element;
        this.parentElement.setAttribute('data-asset-selector-id', this.uid);
        this.searchResults = [];
        this.resultsPageIndex = 0;
        this.selectedPageIndex = 0;
        this.resultsPerPage = resultsPerPage || 10;
       
        window[this.uid] = this;
        this.selectedItems = [];
        this.buildUI();
    }

    show (style){
      this.parentElement.style.display = (style || 'block');
    }

    
    hide (){
      this.parentElement.style.display = 'none';
    }

    setTitle (title){
      if(this.title)
        this.title.innerHTML = title;
    }

    getTranslation (key, defaultValue){
      if(window.AtheneumInstance){
        return window.AtheneumInstance.Translation.get(key, defaultValue);
      }else{
        return defaultValue
      }
    }

    getBooleanTheme (key, defaultValue){
      if(window.AtheneumInstance){
        return window.AtheneumInstance.Theme.getBooleanProperty(key, defaultValue);
      }else{
        return defaultValue
      }
    }

    getIntTheme (key, defaultValue){
      if(window.AtheneumInstance){
        return window.AtheneumInstance.Theme.getIntegerProperty(key, defaultValue);
      }else{
        return defaultValue
      }
    }


    uuidv4 () {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
      }
      
    /**
     * @param {String} HTML representing a single element
     * @return {Element}
     */
    htmlToElement  (html) {
      let template = document.createElement('template');
      html = html.trim(); // Never return a text node of whitespace as the result
      template.innerHTML = html;
      return template.content.firstChild;
    }

    toggleFilters  (){
      if(this.wrapper){
        this.wrapper.classList.toggle("minimised");
      }
    }

    hideFilters  (){
      if(this.wrapper){
        if(!this.wrapper.classList.contains('minimised'))
          this.wrapper.classList.toggle("minimised");
      }
    }

    
    showFilters  (){
      if(this.wrapper){
        this.wrapper.classList.remove("minimised");
      }
    }

    cancelPopups(){
      this.addPopupContent.classList.remove("active");
      this.removePopupContent.classList.remove("active");
      this.removeAssetInfoPopupContent.classList.remove("active");

      document.querySelector('#updatingPopupHighPriorityInput').checked = false;
      document.getElementById("updatingAssetTitle").value = "";
      document.getElementById("updatingAssetDescription").value = "";

      document.querySelector('#addPopupHighPriorityInput').checked = false;
      document.getElementById("relatedAssetTitle").value = "";
      document.getElementById("relatedAssetDescription").value = "";

    }

    updateSelectedAsset(){
      
      this.updatingAsset.highPriority = document.querySelector('#updatingPopupHighPriorityInput').checked;
      this.updatingAsset.title = document.getElementById("updatingAssetTitle").value;      
      this.updatingAsset.description = document.getElementById("updatingAssetDescription").value;

      this.selectedItems =  this.selectedItems.map(u => u.id !== this.updatingAsset.id ? u : this.updatingAsset);
      this.renderSelectedItems();

      this.addPopupContent.classList.remove("active");
      this.removeAssetInfoPopupContent.classList.remove("active");

      document.querySelector('#updatingPopupHighPriorityInput').checked = false;
      document.getElementById("updatingAssetTitle").value = "";
      document.getElementById("updatingAssetDescription").value = "";
    
    }

    addSelectedAsset(){
      let highPriority = document.querySelector('#addPopupHighPriorityInput').checked;
      let assetTitle = document.getElementById("relatedAssetTitle").value;
      let assetDescription = document.getElementById("relatedAssetDescription").value;
      

      this.liElement.classList.add('selected');
      if(!this.selectedItems.some(x=> x.id === this.selectedAsset.id))

      this.selectedAsset.title = assetTitle;
      this.selectedAsset.description = assetDescription;
      this.selectedAsset.highPriority = highPriority;
      
      this.selectedItems.push(this.selectedAsset);
      this.renderSelectedItems();

      this.addPopupContent.classList.remove("active");
      this.removeAssetInfoPopupContent.classList.remove("active");

      document.querySelector('#addPopupHighPriorityInput').checked = false;
      document.getElementById("relatedAssetTitle").value = "";
      document.getElementById("relatedAssetDescription").value = "";
      
    }

    openRemoveAssetPopup(){
      this.addPopupContent.classList.remove("active");
      this.removeAssetInfoPopupContent.classList.remove("active");
      this.removePopupContent.classList.add("active");

      this.removeAssetTitle.innerHTML = " <span style =font-weight:600;>Remove this asset?</span>";

    }

    removeSelectedAsset(){

      if(this.removeSelectedResultsLi != null){
        this.removeSelectedResultsLi.classList.remove('selected');
      }

      this.removeLiElement.remove();
      this.selectedItems = this.selectedItems.filter(x=> x.id !== this.removeSelectedAssetId);

      this.removePopupContent.classList.remove("active");
    }

    addAssetPopup(){
      this.addPopupContent =  this.htmlToElement("<div id='add-popup-content'></div>");
      this.addAssetTitle =  this.htmlToElement("<div id='add-popup-content-title'></div>");
      this.addAssetHighPriorityContainer = this.htmlToElement("<div id='add-popup-high-priority'>  </div>");
      this.addAssetHighPriorityLabel = this.htmlToElement("<label>"+this.getTranslation('relatedAssetsHighPriority', 'High Priority')+"</label>");
      this.addAssetHighPriorityInput = this.htmlToElement("<input id='addPopupHighPriorityInput' type='checkbox'>");
      this.inputTitle =  this.htmlToElement("<input type='text' id='relatedAssetTitle' name='title' placeholder='"+this.getTranslation('relatedAssetsTitle', 'Title')+"'></input>");
      this.inputDescription =  this.htmlToElement("<textarea rows='5' id='relatedAssetDescription' name='description' placeholder='"+this.getTranslation('relatedAssetsDescription', 'Description')+"'></textarea>");
      this.addAssetButtonWrapper = this.htmlToElement("<div class='buttonsWrapper'></div>");
      this.addAssetCancelButton =  this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].cancelPopups()" class="btn default btn-secondary"><span>'+this.getTranslation('cancel', 'Cancel')+'</span></button>');
      this.addAssetAddButton = this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].addSelectedAsset()" class="btn salestoolkit-blue btn-primary"><span>'+this.getTranslation('add', 'Add')+'</span></button>');

      this.addAssetButtonWrapper.appendChild(this.addAssetCancelButton);
      this.addAssetButtonWrapper.appendChild(this.addAssetAddButton);

      this.addAssetHighPriorityContainer.appendChild(this.addAssetHighPriorityLabel);
      this.addAssetHighPriorityContainer.appendChild(this.addAssetHighPriorityInput);

      this.addPopupContent.appendChild(this.addAssetTitle);
      this.addPopupContent.appendChild(this.addAssetHighPriorityContainer);
      this.addPopupContent.appendChild(this.inputTitle);
      this.addPopupContent.appendChild(this.inputDescription);
      this.addPopupContent.appendChild(this.addAssetButtonWrapper);
    }

    removeAssetInfoPopup(){
      this.removeAssetInfoPopupContent =  this.htmlToElement("<div id='remove-info-popup-content'></div>");
      this.removeAssetInfoTitle =  this.htmlToElement("<div id='remove-info-popup-content-title'></div>");
      this.removeAssetInfoHighPriorityContainer = this.htmlToElement("<div id='updating-popup-high-priority'> </div>");
      this.removeAssetInfoHighPriorityLabel = this.htmlToElement("<label>"+this.getTranslation('relatedAssetsHighPriority', 'High Priority')+"</label>");
      this.removeAssetInfoHighPriorityInput = this.htmlToElement("<input id='updatingPopupHighPriorityInput' type='checkbox' checked>");      
      this.removeAssetInfoInputTitle =  this.htmlToElement("<input type='text' id='updatingAssetTitle' name='title' placeholder='"+this.getTranslation('relatedAssetsTitle', 'Title')+"'></input>");
      this.removeAssetInfoInputDescription =  this.htmlToElement("<textarea rows='5' id='updatingAssetDescription' name='description' placeholder='"+this.getTranslation('relatedAssetsDescription', 'Description')+"'></textarea>");
      this.removeAssetInfoButtonWrapper = this.htmlToElement("<div class='buttonsWrapper'></div>");
      this.removeAssetInfoCancelButton =  this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].cancelPopups()" class="btn default btn-secondary"><span>'+this.getTranslation('cancel', 'Cancel')+'</span></button>');
      this.removeAssetInfoAddButton = this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].updateSelectedAsset()" class="btn salestoolkit-blue btn-primary"><span>'+this.getTranslation('update', 'Update')+'</span></button>');
      this.removeAssetInfoRemoveButton = this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].openRemoveAssetPopup()" class="btn salestoolkit-blue btn-primary"><span>'+this.getTranslation('delete', 'Delete')+'</span></button>');

      this.removeAssetInfoButtonWrapper.appendChild(this.removeAssetInfoCancelButton);
      this.removeAssetInfoButtonWrapper.appendChild(this.removeAssetInfoAddButton);
      this.removeAssetInfoButtonWrapper.appendChild(this.removeAssetInfoRemoveButton);
      this.removeAssetInfoHighPriorityContainer.appendChild(this.removeAssetInfoHighPriorityLabel);
      this.removeAssetInfoHighPriorityContainer.appendChild(this.removeAssetInfoHighPriorityInput);
      this.removeAssetInfoPopupContent.appendChild(this.removeAssetInfoTitle);
      this.removeAssetInfoPopupContent.appendChild(this.removeAssetInfoHighPriorityContainer);
      this.removeAssetInfoPopupContent.appendChild(this.removeAssetInfoInputTitle);
      this.removeAssetInfoPopupContent.appendChild(this.removeAssetInfoInputDescription);
      this.removeAssetInfoPopupContent.appendChild(this.removeAssetInfoButtonWrapper);

    }

    removeAssetConfirmationPopup(){
      this.removePopupContent =  this.htmlToElement("<div id='remove-popup-content'></div>");
      this.removeAssetTitle =  this.htmlToElement("<div id='remove-popup-content-title'></div>");
      this.removeAssetButtonWrapper = this.htmlToElement("<div class='buttonsWrapper'></div>");
      this.removeAssetCancelButton =  this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].cancelPopups()" class="btn default btn-secondary"><span>'+this.getTranslation('cancel', 'Cancel')+'</span></button>');
      this.removeAssetRemoveButton = this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].removeSelectedAsset()" class="btn salestoolkit-blue btn-primary"><span>'+this.getTranslation('confirm', 'Confirm')+'</span></button>');

      this.removeAssetButtonWrapper.appendChild(this.removeAssetCancelButton);
      this.removeAssetButtonWrapper.appendChild(this.removeAssetRemoveButton);
      this.removePopupContent.appendChild(this.removeAssetTitle);
      this.removePopupContent.appendChild(this.removeAssetButtonWrapper);
    }

    buildUI (){
      // <div class="form-group">
      //                           <label class="control-label profile-label required" data-translation-key="userName"
      //                               data-translation-default="Username">Username</label>
      //                           <input class="profile-input required" type="text" id="salestoolkit-user-name"
      //                               name="userName" placeholder="" class="form-control" autocapitalize="none" />
      //                       </div>
        this.wrapper =  this.htmlToElement("<div class='assetPickerMainWrapper' id='"+this.uid+"MainWrapper'></div>");
        this.title =  this.htmlToElement("<div class='assetPickerTitle' id='"+this.uid+"TitleWrapper'></div>");
        this.filters = this.htmlToElement("<div class='assetPickerFiltersWrapper' id='"+this.uid+"FiltersWrapper'></div>");
        this.items = this.htmlToElement("<div class='assetPickerItemsWrapper' id='"+this.uid+"ItemsWrapper'></div>");
        this.results = this.htmlToElement("<div class='assetPickerResultsWrapper' id='"+this.uid+"ResultsWrapper'></div>");
        this.spacer = this.htmlToElement("<div class='assetPickerSpacer'></div>");
        this.selected = this.htmlToElement("<div class='assetPickerSelectedWrapper' id='"+this.uid+"SelectedWrapper'></div>");
       
        this.items.appendChild(this.results);
        this.items.appendChild(this.spacer);
        this.items.appendChild(this.selected);
        this.wrapper.appendChild(this.title);
        this.wrapper.appendChild(this.filters);
        this.wrapper.appendChild(this.items);

        let element = this.parentElement;
        element.innerHTML = "";

        let searchGroups = this.htmlToElement('<div class="searchGroups"></div>');

        this.searchOptions.forEach(searchOption => {
            let searchGroup = this.htmlToElement('<div class="searchGroup"></div>');
            let name = searchOption.name;
            if(searchOption.hasOwnProperty('ancestors')){
              name = "ancestor_"+name;
            }
            let searchLabel = this.htmlToElement('<label for="'+name+'"class="" id="'+this.uid+'"FiltersWrapper">'+searchOption.label+'</label>');
            let searchInput = this.htmlToElement('<input name="'+name+'" class="'+(this.uid + name)+'" type="'+searchOption.type+'" placeholder="'+(searchOption.placeholder || '')+'" />');
            
            searchGroup.appendChild(searchLabel);
            searchGroup.appendChild(searchInput);
            searchGroups.appendChild(searchGroup);
        });

        this.filters.appendChild(searchGroups);

        let buttons = this.htmlToElement('<div class="buttonsWrapper">'+
        '<button type="button" onclick="window[\''+this.uid+'\'].clearSearch()" class="btn salestoolkit-blue btn-secondary"><span>'+this.getTranslation('clearAllSearchAssets', 'Clear All')+'</span></button>'+
        '<button type="button" onclick="window[\''+this.uid+'\'].executeSearch()" class="btn salestoolkit-blue btn-secondary"><span>'+this.getTranslation('searchAssets', 'Search Assets')+'</span></button>'+
        '<button type="button" onclick="window[\''+this.uid+'\'].toggleFilters()" class="btn salestoolkit-blue btn-primary"><span>'+this.getTranslation('toggleFilters', 'Toggle Filters')+'</span></button>'+
        '</div>');

        this.filters.appendChild(buttons);
        element.appendChild(this.wrapper);
        
        //Results section
         this.resultsUL = this.htmlToElement('<ul class="results-list"></ul>');
        buttons = this.htmlToElement('<div class="buttonsWrapper"></div>');
       

        this.results.appendChild(this.resultsUL);
       

        this.previousResultButton = this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].previousResultsPage()" '+
        'class="btn salestoolkit-blue btn-primary" ><span>'+this.getTranslation('previousPage', 'Previous')+'</span></button>');
        this.resultsPagesText = this.htmlToElement('<span class="'+this.uid+'ResultsText" ></span>');
        this.nextResultButton = this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].nextResultsPage()" '+
        'class="btn salestoolkit-blue btn-primary" ><span>'+this.getTranslation('nextPage', 'Next')+'</span></button>');

        buttons.appendChild(this.previousResultButton);
        buttons.appendChild(this.resultsPagesText);
        buttons.appendChild(this.nextResultButton);
        
        this.results.appendChild(buttons);

        //Selected section
        this.selectedUL = this.htmlToElement('<ul class="selected-list"></ul>');
        buttons = this.htmlToElement('<div class="buttonsWrapper"></div>');
       

        this.selected.appendChild(this.selectedUL);
       

        this.previousSelectedButton = this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].previousSelectedPage()" '+
        'class="btn salestoolkit-blue btn-primary" ><span>'+this.getTranslation('previousPage', 'Previous')+'</span></button>');
        this.selectedPagesText = this.htmlToElement('<span class="'+this.uid+'SelectedText" ></span>');
        this.nextSelectedButton = this.htmlToElement('<button type="button" onclick="window[\''+this.uid+'\'].nextSelectedPage()" '+
        'class="btn salestoolkit-blue btn-primary '+this.uid+'nextResultButton"><span>'+this.getTranslation('nextPage', 'Next')+'</span></button>');
        buttons.appendChild(this.previousSelectedButton);
        buttons.appendChild(this.selectedPagesText);
        buttons.appendChild(this.nextSelectedButton);

        this.selected.appendChild(buttons);

        this.addAssetPopup();
        this.removeAssetConfirmationPopup();
        this.removeAssetInfoPopup();

        this.wrapper.appendChild(this.addPopupContent);
        this.wrapper.appendChild(this.removePopupContent);
        this.wrapper.appendChild(this.removeAssetInfoPopupContent);

    }

    clearSearch (){
      this.searchResults = [];
      let inputs = [...this.filters.getElementsByTagName('input')];
      inputs.forEach(element => {
        element.value = "";
      });
    }

    setSelectedItems (assets){
      
      this.selectedItems = assets;
      this.resultsUL.querySelectorAll('.selected').forEach(x=> x.classList.remove('selected'));
      this.renderSelectedItems();
      this.renderResultsPage();
    }

    setSelectedItemsByIds (assetIds){
      this.selectedItems = this.assets.filter(x=> assetIds.filter(y=> y.id === x.id).length > 0);

      this.resultsUL.querySelectorAll('.selected').forEach(x=> x.classList.remove('selected'));

      this.resultsUL.querySelectorAll('.selected').forEach(x=> x.classList.remove('selected'));

      this.renderSelectedItems();
      this.renderResultsPage();
    }

    ancestorMatchesProperety (asset, propertyName, value){
       if(!window.AtheneumInstance)
       {
        //No way of finding out as we don't have access to atheneum 
        return false;
       }

       try{
        let collection = window.AtheneumInstance.Library.collections[asset.containedBy];
        if(collection.hasOwnProperty(propertyName) && collection[propertyName].toLowerCase().indexOf(value) >= 0)
          return true;

        while(collection.containedBy != null){
          collection =  window.AtheneumInstance.Library.collections[collection.containedBy];
          if(collection.hasOwnProperty(propertyName) && collection[propertyName].toLowerCase().indexOf(value) >= 0)
            return true;
        }
       }catch(err){
        console.log(err);
       }

       return false;
      
    }

    parseYMDHM(s) {
      try {
          let b = s.split(/\D+/);
          return new Date(b[0], --b[1], b[2], b[3], b[4], b[5] || 0, b[6] || 0);
      } catch (err) {
          return new Date();
      }

    }

    executeSearch (){
      this.searchResults = this.assets;
      let assetManager = this;
      this.searchOptions.forEach(searchOption => {
        let name = searchOption.name;
            if(searchOption.hasOwnProperty('ancestors')){
              name = "ancestor_"+name;
            }

          let input = assetManager.filters.getElementsByClassName(assetManager.uid + name)[0];
          let value = input?.value || '';

          if(value.trim() == '')
            return;

          value = value.toLowerCase();

          if(searchOption.hasOwnProperty('ancestors')){
            assetManager.searchResults = assetManager.searchResults.filter(x=> assetManager.ancestorMatchesProperety(x, searchOption.name, value));
            return;
          }

          if(searchOption.type === 'date'){
            value = new Date(value);
            value.setHours(0,0,0,0);
            value =  value.getTime() - (value.getTimezoneOffset() * 1000 * 60);
            assetManager.searchResults = assetManager.searchResults.filter((x) => { 
                if(!x.hasOwnProperty(searchOption.name)){
                  return false;
                }

                let itemDate = new Date(x[searchOption.name]);
                itemDate.setHours(0,0,0,0);
                itemDate = itemDate.getTime() - (itemDate.getTimezoneOffset() * 1000 * 60);
                return itemDate === value;
              });
    
            return;
          }

          assetManager.searchResults = assetManager.searchResults.filter(x=> x.hasOwnProperty(searchOption.name) && x[searchOption.name].toLowerCase().indexOf(value) >= 0);
      });

      if(this.getBooleanTheme('fullTitleLastForAssetSelector', true)){
          assetManager.searchResults.sort(function (a, b) {
            if (a.name && !b.name)
                return 1;
            if (!a.name && b.name)
                return -1;
            if (!a.name && !b.name)
                return 0;
    
            let aName = $("<div>"+a.name + " - " + a.fullTitle+"</div>").text();
            let bName = $("<div>"+b.name + " - " + b.fullTitle+"</div>").text();
           
            if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
            if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
            return 0;
        });
      }else{
        assetManager.searchResults.sort(function (a, b) {
          if (a.name && !b.name)
              return 1;
          if (!a.name && b.name)
              return -1;
          if (!a.name && !b.name)
              return 0;
  
          let aName = $("<div>"+a.fullTitle + " - " + a.name+"</div>").text();
          let bName = $("<div>"+b.fullTitle + " - " + b.name+"</div>").text();
         
          if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
          if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
          return 0;
      });
      }
    
      this.resultsPageIndex = 0;
      this.selectedPageIndex = 0;
      this.renderResultsPage();
    }

    getPageItems  (array, page_size, page_number) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      return array.slice((page_number - 1) * page_size, page_number * page_size);
    }

    nextResultsPage (){
      let numPages = Math.ceil(this.searchResults.length / this.resultsPerPage);
      if((this.resultsPageIndex + 1) < numPages){
        this.resultsPageIndex += 1;
        this.renderResultsPage()
      }
    }

    previousResultsPage (){
      if(this.resultsPageIndex == 0)
        return;
      
      this.resultsPageIndex -= 1;
      this.renderResultsPage();
    }

    renderResultsPage (){
      let numPages = Math.ceil(this.searchResults.length / this.resultsPerPage);
      if(this.resultsPageIndex == 0){
        this.previousResultButton.classList.toggle('disabled', true);
      }else{
        this.previousResultButton.classList.toggle('disabled', false);
      }
      
      if(this.resultsPageIndex + 1 >= numPages){
        this.nextResultButton.classList.toggle('disabled', true);
      }else{
        this.nextResultButton.classList.toggle('disabled', false);
      }

      let pageNumber =  this.resultsPageIndex + 1;
      if(numPages == 0)
        pageNumber = 0;

      let resultText = this.getTranslation('pages', '{0}/{1}').replaceAll('{0}', pageNumber).replaceAll('{1}', numPages);
      this.resultsPagesText.innerHTML = resultText;
    
      this.resultsUL.innerHTML = "";
      let pageItems = this.getPageItems(this.searchResults, this.resultsPerPage, this.resultsPageIndex + 1);

      pageItems.forEach(asset => {
        let name = asset.fullTitle +' - '+ asset.name; 
        if(this.getBooleanTheme('fullTitleLastForAssetSelector', true)){
          name = asset.name +' - '+ asset.fullTitle; 
        }

        let collection = SalesToolkit.Library.collections[asset.containedBy];
        if(this.getBooleanTheme('assetSelectorNamesIncludeCollections', false) && collection){
            name = collection.name;
            while (collection.containedBy != null) {
              collection = SalesToolkit.Library.collections[collection.containedBy];
              name = name + " - " + collection.name;
            }

            name = asset.name + " - " + name;
        }

        let selected = "";
        if(this.selectedItems.some(x=> x.id === asset.id)){
          selected = "selected"
        }
        let resultLI = this.htmlToElement('<li class="'+selected+' '+this.uid+asset.id+'Result" onclick="window[\''+this.uid+'\'].toggleSelectedItem(this, \''+asset.id+'\')" data-asset-id="'+asset.id+'">'+name+'</label>');
        this.resultsUL.appendChild(resultLI);
      });
      
    }

    toggleSelectedItem (liElement, assetId){
      let asset = this.assets.filter(x=> x.id === assetId)[0];
      if(!asset)
      {
        console.log('asset not found to be added');
        return;
      }

      if(!liElement.classList.contains('selected')){

       
        this.cancelPopups();            
        this.addPopupContent.classList.add("active");
        this.addAssetTitle.innerHTML = asset.fullTitle;

        this.liElement = liElement;
        this.selectedAsset = asset;
        
      }
    }

    nextSelectedPage (){
      let numPages = Math.ceil(this.selectedItems.length / this.resultsPerPage);
      if((this.selectedPageIndex + 1) < numPages){
        this.selectedPageIndex += 1;
        this.renderSelectedItems()
      }
    }

    previousSelectedPage (){
      if(this.selectedPageIndex == 0)
        return;
      
      this.selectedPageIndex -= 1;
      this.renderSelectedItems();
    }

    removeSelectedItem (liElement, assetId){
      let asset = this.assets.filter(x=> x.id === assetId)[0];

      let resultsLi = this.resultsUL.getElementsByClassName(this.uid+assetId+'Result')[0] || null;
      //If not null then it's currently rendered in the results list
      //if(resultsLi != null){

        this.addPopupContent.classList.remove("active");
        this.removePopupContent.classList.remove("active"); 
        this.removeAssetInfoPopupContent.classList.add("active");

        this.removeAssetInfoTitle.innerHTML = asset.fullTitle;

        this.removeAssetInfoHighPriorityInput.checked = asset.highPriority || false;
        this.removeAssetInfoInputTitle.value = asset.title || "";
        this.removeAssetInfoInputDescription.value = asset.description || "";



        this.removeLiElement = liElement;
        this.removeSelectedResultsLi = resultsLi;
        this.removeSelectedAssetId = assetId;
        this.updatingAsset = asset;
        
      //}
    }




    renderSelectedItems (){
      let numPages = Math.ceil(this.selectedItems.length / this.resultsPerPage);
      if(this.selectedPageIndex == 0){
        this.previousSelectedButton.classList.toggle('disabled', true);
      }else{
        this.previousSelectedButton.classList.toggle('disabled', false);
      }
      
      if(this.selectedPageIndex + 1 >= numPages){
        this.nextSelectedButton.classList.toggle('disabled', true);
      }else{
        this.nextSelectedButton.classList.toggle('disabled', false);
      }

      let pageNumber =  this.selectedPageIndex + 1;
      if(numPages == 0)
        pageNumber = 0;
      let selectText = this.getTranslation('pages', '{0}/{1}').replaceAll('{0}', pageNumber).replaceAll('{1}', numPages);
      this.selectedPagesText.innerHTML = selectText;
    
      this.selectedUL.innerHTML = "";
      let pageItems = this.getPageItems(this.selectedItems, this.resultsPerPage, this.selectedPageIndex + 1);
      if(this.getBooleanTheme('fullTitleLastForAssetSelector', true)){
          pageItems.sort(function (a, b) {
            if (a.name && !b.name)
                return 1;
            if (!a.name && b.name)
                return -1;
            if (!a.name && !b.name)
                return 0;
    
            let aName = $("<div>"+a.name + " - " + a.fullTitle+"</div>").text();
            let bName = $("<div>"+b.name + " - " + b.fullTitle+"</div>").text();
          
            if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
            if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
            return 0;
        });
       }else{
          pageItems.sort(function (a, b) {
            if (a.name && !b.name)
                return 1;
            if (!a.name && b.name)
                return -1;
            if (!a.name && !b.name)
                return 0;
    
            let aName = $("<div>"+a.fullTitle + " - " + a.name+"</div>").text();
            let bName = $("<div>"+b.fullTitle + " - " + b.name+"</div>").text();
          
            if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
            if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
            return 0;
        });
     }
      pageItems.forEach(asset => {
        let name = asset.fullTitle +' - '+ asset.name; 
        if(this.getBooleanTheme('fullTitleLastForAssetSelector', true)){
          name = asset.name +' - '+ asset.fullTitle; 
        }
        let collection = SalesToolkit.Library.collections[asset.containedBy];
        if(this.getBooleanTheme('assetSelectorNamesIncludeCollections', false) && collection){
          name = collection.name;
          while (collection.containedBy != null) {
            collection = SalesToolkit.Library.collections[collection.containedBy];
            name = name + " - " + collection.name;
          }

          name = asset.name + " - " + name;
        }

        let selectedLI = this.htmlToElement('<li class="'+this.uid+asset.id+'Selected" onclick="window[\''+this.uid+'\'].removeSelectedItem(this, \''+asset.id+'\')" data-asset-id="'+asset.id+'">'+name+'</label>');
        this.selectedUL.appendChild(selectedLI);
      });
    }
}